import router from './router';
import apiContainer from '../services/api';
import CommandsController from './services/commandsController.service';
import QueriesController from './services/queriesController.service';
import Paths from './services/paths';
import { Persistance } from '@/common';
import { useSessionStore } from '@/common';
import { loadUserData, getChildrenData, persisteChildSelection, getChildData } from './services';
import { login } from './services';

const API = apiContainer.apiController();

const CommandsControllerFactory = () => new CommandsController(API, Paths, Persistance);
const QueriesControllerFactory = () =>
  new QueriesController(API, Paths, Persistance, useSessionStore());

const container = {
  commandsController: CommandsControllerFactory,
  queriesController: QueriesControllerFactory,
  persistanceController: Persistance,
};

Object.freeze(container);

export {
  router,
  container,
  loadUserData,
  getChildrenData,
  persisteChildSelection,
  getChildData,
  login,
};
